module.exports = __webpack_public_path__ + "assets/img/seal-31a8f7fa.png";